import React from 'react';

const UserCenter = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_84_3361)">
      <path
        d="M45.4702 17.2515C46.1392 19.3815 46.5 21.6488 46.5 24C46.5 36.4268 36.4268 46.5 24 46.5C11.5732 46.5 1.5 36.4268 1.5 24C1.5 11.5732 11.5732 1.5 24 1.5C28.9725 1.5 33.57 3.111 37.2937 5.8425"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M40.5 13.5C42.9853 13.5 45 11.4853 45 9C45 6.51472 42.9853 4.5 40.5 4.5C38.0147 4.5 36 6.51472 36 9C36 11.4853 38.0147 13.5 40.5 13.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M33 33.75V30.7762C33 29.7112 32.4412 28.7317 31.5247 28.1895C30.066 27.3262 27.537 26.25 24 26.25C20.4173 26.25 17.9047 27.3195 16.461 28.1813C15.552 28.7243 15 29.7008 15 30.7598V33.75H33Z"
        fill="#FB6121"
        stroke="#FB6121"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M24 21.75C26.4853 21.75 28.5 19.7353 28.5 17.25C28.5 14.7647 26.4853 12.75 24 12.75C21.5147 12.75 19.5 14.7647 19.5 17.25C19.5 19.7353 21.5147 21.75 24 21.75Z"
        fill="#FB6121"
        stroke="#FB6121"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_84_3361">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UserCenter;
